import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs/Observable';

import {BaseHttpService} from '../base.service';
import {SessionService} from '../session.service';
import {HolidayModel} from '../../../ecv-project/holiday/holiday.model';




@Injectable()
export class HolidayService extends BaseHttpService {
  private static timeTrackerPath = 'api/timetrackers';
  private static createHolidayPath = HolidayService.timeTrackerPath + '/request_holiday';
  private static holidaysPath = 'api/holidays/';

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  createHoliday(model: HolidayModel): Observable<any> {
    return this.httpPost(HolidayService.createHolidayPath, model);
  }

  getHolidaysByYearMonth(year: number, month: number): Observable<any> {
    return this.httpGet(HolidayService.holidaysPath + year + '/' + month);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/holiday.service.ts